import {DropdownListWidget} from './DropdownList'
import {FormWidget} from './Form/FormWidget@desktop'
import {IconWidget} from './Icon/index@desktop'
import {IconSpotWidget} from './IconSpot/index@desktop'
import {NavWidget} from './Nav/index.desktop'
import {RadioWidget} from './Radio'
import {SegmentWidget} from './Segment/index@desktop'
import {SlotWidget} from './Slot/index@desktop'
import {SwitchWidget} from './Switch/SwitchDesktop'
import {TextWidget} from './Text/index.desktop'
import {type WidgetConfig, WidgetType} from './types'
import {VerticalsWidget} from './Verticals/VeticalsWidget/VerticalsWidget@desktop'

export const mapTypeToWidget = {
  // [WidgetType.ADDRESS]: AddressWidget,
  // [WidgetType.DIVIDER]: DividerWidget,
  [WidgetType.FORM]: FormWidget,
  // [WidgetType.HEADER]: HeaderWidget,
  [WidgetType.ICON]: IconWidget,
  // [WidgetType.ICON_BUTTON]: IconButtonWidget,
  [WidgetType.ICON_SPOT]: IconSpotWidget,
  [WidgetType.NAV]: NavWidget,
  // [WidgetType.IMAGE]: ImageWidget,
  [WidgetType.RADIO]: RadioWidget,
  [WidgetType.SEGMENT]: SegmentWidget,
  [WidgetType.SLOT]: SlotWidget,
  [WidgetType.SWITCH]: SwitchWidget,
  // [WidgetType.TAG_LINE]: TagLineWidget,
  [WidgetType.TEXT]: TextWidget,
  [WidgetType.DROPDOWN_LIST]: DropdownListWidget,
  // [WidgetType.TEXT_INPUT]: TextInputWidget,
  // [WidgetType.PHONE_INPUT]: PhoneInputWidget,
  // [WidgetType.COST_DETAIL]: CostDetailWidget,
  // [WidgetType.COUNTER]: CounterWidget,
  [WidgetType.VERTICALS]: VerticalsWidget,
}

export function renderWidget<T extends WidgetConfig>(externalProps: T, index?: number | string): React.ReactNode {
  const Component = mapTypeToWidget[externalProps.type]

  if (Component) {
    const props = 'key' in externalProps ? {...externalProps, name: externalProps.key} : externalProps
    const key = 'widget_id' in props ? `${props.widget_id}_${index}` : index

    return <Component key={key} config={props} />
  }

  // TODO: Выкидывать ошибку после завершения разработки виджетов
  // throw new Error(`Виджет ${props.type} не найден`)
  return null
}
